/* ============================================================
   Home Elektro — Wishlist Engine
   localStorage key: he_wishlist
   Items: [{ id, handle, title, price (cents), image }]
   ============================================================ */
(function () {
  'use strict';

  /* Guard against double-loading (theme.liquid + section includes) */
  if (window._heWishlistReady) return;
  window._heWishlistReady = true;

  var KEY = 'he_wishlist';

  function load() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  }
  function persist(items) {
    try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) {}
    window.dispatchEvent(new CustomEvent('wishlist:change', { detail: { items: items } }));
  }

  var WL = {
    getAll: function () { return load(); },
    count:  function () { return load().length; },
    has:    function (id) {
      id = String(id);
      return load().some(function (p) { return String(p.id) === id; });
    },
    add: function (item) {
      var items = load();
      var id = String(item.id);
      if (!items.some(function (p) { return String(p.id) === id; })) {
        items.unshift({ id: id, handle: item.handle || '', title: item.title || '', price: item.price || 0, image: item.image || '' });
        persist(items);
      }
    },
    remove: function (id) {
      id = String(id);
      persist(load().filter(function (p) { return String(p.id) !== id; }));
    },
    toggle: function (item) {
      this.has(item.id) ? this.remove(item.id) : this.add(item);
    }
  };

  window.HEWishlist = WL;

  /* ── Inject shared styles once ── */
  if (!document.getElementById('he-wl-css')) {
    var s = document.createElement('style');
    s.id = 'he-wl-css';
    s.textContent = [
      /* Heart button on product cards */
      '.he-wish-btn{position:absolute;top:10px;right:10px;width:34px;height:34px;background:rgba(255,255,255,.95);border:1.5px solid #E8E8E4;border-radius:50%;display:flex;align-items:center;justify-content:center;cursor:pointer;z-index:4;transition:border-color .2s,background .2s,transform .2s;padding:0;flex-shrink:0}',
      '.he-wish-btn:hover{border-color:#CC0000;transform:scale(1.12)}',
      '.he-wish-btn svg{width:15px;height:15px;stroke:#999;fill:none;transition:stroke .2s,fill .2s;pointer-events:none}',
      '.he-wish-btn.is-wished{border-color:#CC0000;background:#FFF5F5}',
      '.he-wish-btn.is-wished svg{stroke:#CC0000;fill:#CC0000}',
      '.he-wish-btn--pop{animation:heWishPop .32s cubic-bezier(.36,.07,.19,.97)}',
      '@keyframes heWishPop{0%{transform:scale(1)}35%{transform:scale(1.4)}65%{transform:scale(.88)}100%{transform:scale(1)}}',
      /* Header wishlist icon */
      '.he-header-wishlist{display:inline-flex;align-items:center;justify-content:center;position:relative;width:40px;height:40px;color:#1C1C1C;text-decoration:none;transition:color .2s,transform .2s}',
      '.he-header-wishlist:hover{color:#CC0000;transform:scale(1.12)}',
      '.he-header-wishlist:hover svg{fill:rgba(204,0,0,0.1)}',
      '.he-header-wishlist svg{width:24px;height:24px;stroke:currentColor;fill:none;transition:fill .2s}',
      '.he-header-wishlist--pop{animation:heHeaderWishPop .35s cubic-bezier(.36,.07,.19,.97)}',
      '@keyframes heHeaderWishPop{0%{transform:scale(1)}30%{transform:scale(1.35)}65%{transform:scale(.9)}100%{transform:scale(1)}}',
      '.he-wish-count{position:absolute;top:2px;right:1px;min-width:16px;height:16px;background:#CC0000;color:#fff;font-size:9px;font-weight:700;border-radius:8px;display:flex;align-items:center;justify-content:center;padding:0 3px;line-height:1;opacity:0;transform:scale(0);transition:opacity .2s,transform .2s;pointer-events:none}',
      '.he-wish-count.has-items{opacity:1;transform:scale(1)}'
    ].join('');
    document.head.appendChild(s);
  }

  /* ── Update header badge ── */
  function updateBadge() {
    var el = document.getElementById('he-wish-count');
    if (!el) return;
    var n = WL.count();
    el.textContent = n > 99 ? '99+' : String(n);
    el.classList.toggle('has-items', n > 0);
  }

  /* ── Sync all heart buttons on the page ── */
  function syncBtns() {
    document.querySelectorAll('.he-wish-btn[data-product-id]').forEach(function (btn) {
      btn.classList.toggle('is-wished', WL.has(btn.dataset.productId));
    });
    updateBadge();
  }

  /* ── Click delegation — works on any dynamically added button ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.he-wish-btn[data-product-id]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var item = {
      id:     btn.dataset.productId,
      handle: btn.dataset.productHandle || '',
      title:  btn.dataset.productTitle  || '',
      price:  parseInt(btn.dataset.productPrice || '0', 10),
      image:  btn.dataset.productImage  || ''
    };
    WL.toggle(item);
    btn.classList.toggle('is-wished', WL.has(item.id));
    /* Pop animation */
    btn.classList.remove('he-wish-btn--pop');
    void btn.offsetWidth; /* reflow to restart */
    btn.classList.add('he-wish-btn--pop');
  });

  window.addEventListener('wishlist:change', syncBtns);

  /* ── Header wishlist icon: click pop animation ── */
  document.addEventListener('click', function(e) {
    var link = e.target.closest('.he-header-wishlist');
    if (!link) return;
    link.classList.remove('he-header-wishlist--pop');
    void link.offsetWidth; /* reflow to restart animation */
    link.classList.add('he-header-wishlist--pop');
    link.addEventListener('animationend', function() {
      link.classList.remove('he-header-wishlist--pop');
    }, { once: true });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncBtns);
  } else {
    syncBtns();
  }
})();
